import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function VisitIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99707 1.66602V2.66602C9.99707 3.60882 9.99707 4.08023 10.2899 4.37312C10.5829 4.66602 11.0543 4.66602 11.9971 4.66602H12.9971"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M2.66406 10.6673V5.33398C2.66406 3.44836 2.66406 2.50556 3.24985 1.91977C3.83564 1.33398 4.77844 1.33398 6.66406 1.33398H9.44513C9.7176 1.33398 9.85386 1.33398 9.9764 1.38473C10.0989 1.43548 10.1953 1.53182 10.3879 1.72451L12.9402 4.27679C13.1329 4.46948 13.2293 4.56582 13.28 4.68834C13.3307 4.81085 13.3307 4.9471 13.3307 5.2196V10.6673C13.3307 12.5529 13.3307 13.4957 12.7449 14.0815C12.1591 14.6673 11.2163 14.6673 9.33073 14.6673H6.66406C4.77844 14.6673 3.83564 14.6673 3.24985 14.0815C2.66406 13.4957 2.66406 12.5529 2.66406 10.6673Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M5.33008 7.33398H10.6634M5.33008 9.33398H10.6634M5.33008 11.334H8.11061"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
